module.exports = __webpack_public_path__ + "static/img/palm-trees@3x.d21bbbe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/backgrounds/palm-trees@3x.jpg
// module id = mPlJ
// module chunks = 1